import styled from 'styled-components';

const Cell = styled.div`
    flex-grow: 1;
    width: 100%;
    padding: 0 15px;
`;

export default Cell;



// WEBPACK FOOTER //
// ./src/components/list/Filters/layout/Cell.js